import { useEffect } from 'react'

import { useDataBoxSelector, useDataBoxStatus } from 'app/common/data-box-store'
import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { getID } from 'app/common/ui-next/plain-selector'
import {
  classTypeFilterSelection,
  classesListFilter,
  classesListFilterSelection,
  defaultClassesListDataReceiver,
  educationLevelsFilter,
  educationLevelsFilterSelection,
  orgsFilterSelection,
  orgTypesFilterSelection,
  parallelsFilterSelection,
  schoolYearFilter,
  schoolYearFilterSelection,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'

import { DetailedSubsidyClassType } from './types'

type Props = { id: string; pending: boolean }

export const ClassesListFilter = ({ id, pending }: Props) => {
  const orgType = useDataBoxSelector(orgTypesFilterSelection, () => orgTypesFilterSelection.data)
  const orgs = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const years = useDataBoxSelector(schoolYearFilterSelection, () => schoolYearFilterSelection.data)
  const classType = useDataBoxSelector(
    classTypeFilterSelection,
    () => classTypeFilterSelection.data,
  )
  const parallels = useDataBoxSelector(
    parallelsFilterSelection,
    () => parallelsFilterSelection.data,
  )
  const education = useDataBoxSelector(
    educationLevelsFilterSelection,
    () => educationLevelsFilterSelection.data,
  )
  const educationLoading = useDataBoxStatus(
    educationLevelsFilter,
    () => educationLevelsFilter.pending,
  )
  const schoolYearLoading = useDataBoxStatus(
    schoolYearFilter,
    () => schoolYearFilter.pending,
  )
  const visible =
    orgs.length === 1 &&
    years.length === 1 &&
    orgType[0] !== OrgType.Enterprise &&
    (orgType[0] !== OrgType.School ||
      (classType[0] === DetailedSubsidyClassType.Common &&
        !educationLoading &&
        !schoolYearLoading))

  useEffect(() => {
    classesListFilterSelection.resetToDefault()
    studentListFilterSelection.resetToDefault()
    if (!visible) {
      classesListFilter.resetToDefault()
      return
    }

    classesListFilter.setStatusPending()
    defaultClassesListDataReceiver().then((items) => {
      const filtered = items.filter(({ title }) => {
        if (
          parallels.length &&
          !parallels.some((value) => new RegExp(`^${value}(?:\\D|$)`).test(title))
        ) {
          return false
        }
        if (!education.length) return true
        const allowedParallels = educationLevelsFilter.data
          .filter((item) => education.includes(String(getID(item))))
          .flatMap((item) => item.parallels || [])
        return (
          !allowedParallels.length ||
          allowedParallels.some((value) => new RegExp(`^${value}(?:\\D|$)`).test(title))
        )
      })
      classesListFilter.updateData(() => filtered)
      classesListFilter.setStatusReady()
    })
  }, [orgs, years, parallels, education, visible])

  if (!visible) return null
  return (
    <PlainItemsSelectorBox
      id={id}
      label={orgType[0] === OrgType.School ? 'Класс' : 'Группа'}
      header={orgType[0] === OrgType.School ? 'Выбор класса' : 'Выбор группы'}
      dataBoxData={classesListFilter}
      dataBoxSelection={classesListFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      multiple
      disabled={pending}
    />
  )
}
